<template lang="pug">
v-container
  Dialog(ref="dialog")
  v-alert(type="info") La conexión "Puente" y "Servidor GG" necesitan que la pc principal del local esté funcionado y conectada 
    |#[br] a internet.
  v-alert(type="warning") Esta aplicación esta en fase Alpha, puede presentar errores y funcionalidad faltante
    |#[br] por favor informenos cualquier detalle a mejorar o cualquier error. Muchas Gracias

  v-row(justify="center" align="center" class="ma-5")
    v-col(cols="12" sm="8" md="6")
      v-form(v-model="valid" lazy-validation
        v-on:submit.prevent="validate"
        v-on:reset="resetForm")
        v-radio-group(v-model="datasource")
          v-radio(label="Mi Comercio" value="MI")
          v-radio(label="Servidor GG" value="GG")
          v-radio(label="Puente GG" value="BR")
        v-text-field(v-if="datasource=='GG'" v-model="serverInfo" :rules="serverInfoRules" label="Ingrese URL del Servidor" required)
        v-text-field(v-model="user" label="Nombre de usuario" required)
        v-text-field(v-model="password" label="Contraseña" required type="password")            
        v-btn(type="submit" color="primary" :disabled="!valid" @click="validate()") Acceder
        v-btn(type="reset" color="error" @click="resetForm()") Cancelar

  </template>
  
  <script>
  import Dialog from "./DialogMsg.vue"
  import bridge from "@/db/bridge"
  export default {
    components:{Dialog},
    data() {
      return {
        valid: false,
        micomercio: false,
        serverInfo: localStorage.getItem("serverInfo"),
        user:"",
        password:"",
        datasource:"BR",
        serverInfoRules: [
          (v) => !!v || "La dirección IP o URL es requerida",
          (v) => /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^((https?|ftp):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/.test(v) || "Formato incorrecto",
        ],
      };
    },
    methods: {
      validateMs() {
        let sql = `SELECT * FROM tabla1 where username = '${this.user}' and pwd = '${this.password}'`
        return this.$axios.post(process.env.VUE_APP_baseURL+'recordset/',{query:sql},{headers:{Authorization:process.env.VUE_APP_AUTH_TOKEN}})
        .then((ret)=>{
          if (ret.data.length > 0) {
            window.serverInfoGG = this.serverInfo
            this.$store.commit('user',ret.data[0]);
            window.licenceid = ret.data[0].id
            localStorage.setItem("serverInfo", this.serverInfo);
            this.$router.push('/')
          } else {
            this.$refs.dialog.show("usuario incorrecto")  
          }
        })
        .catch((err)=>{
          this.$refs.dialog.show(err.message)
        })
      },
      validate() {
        window.datasource=this.datasource
        if (this.datasource=='MI' || this.datasource=='BR' ) {
          this.validateMs()
          return 
        }
        if (!this.serverInfo.includes("http")) {
          this.serverInfo = "http://" + this.serverInfo + ":8055/"
        }
        window.serverInfoGG = this.serverInfo
        let sql = `SELECT admin, Id, apodo, reportes, stock from usuarios where apodo = '${this.user}' and password = '${this.password}'`
        bridge.post('v1/recordset/',sql)
        .then((ret)=>{
          if (ret.data.length > 0) {
            this.$store.commit('user',ret.data[0]);
            this.$store.commit('micomercio',false);
            localStorage.setItem("serverInfo", this.serverInfo);
            this.$router.push('/')
          } else {
            this.$refs.dialog.show("usuario incorrecto")  
          }
        })
        .catch((err)=>{
          this.$refs.dialog.show(err.message)
        })
 
      },
      resetForm() {
        this.$refs.form.reset();
        this.valid = false;
      },
    },
    created() {
      // Inicializa serverInfo desde localStorage si está disponible
      const savedServerInfo = localStorage.getItem("serverInfo");
      if (savedServerInfo) {
        this.serverInfo = savedServerInfo;
        this.valid = true;
      }
    },
  };
  </script>
  